import { RootState } from '@reducers';

export const selectPersonalInfoEdit = (state: RootState) => state.userDashboardRouteReducer.personalInfoEditReducer;
